import React, { useState } from 'react'
import Button from '@material-ui/core/Button';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, makeStyles, TableCell, TableRow, Typography } from '@material-ui/core';
import { postTomarComprobante, putLiberarComprobante, setComprobanteSeleccionado } from '../../../actions/liquidaciones/liquidaciones';
import { LIQUIDACIONES_COMPROBANTES_ESTADOS } from '../../../utils/constants';
import IconEstado from '../../autorizaciones/UI/IconEstado';
import { ModalAuditarFactura } from './ModalAuditarFactura';
import InfoHistorialIcon from '../../autorizaciones/UI/InfoHistorialIcon';
import { ModalHistorialExpedientes } from '../../MesaEntrada/UI/ModalHistorialExpedientes';
import { formatCurrencyPesos } from '../../../helpers/extraFunctions';

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const ComprobanteLiqItem = ({ item, isItemSelected, labelId, handleClick, estadoComprobantes,
  fechaDesde, fechaHasta, idEfectorFacturacion }) => {
  const classes = useRowStyles();
  const dispatch = useDispatch();

  const { idUsuario } = useSelector((state) => state.auth);
  const { comprobantesTomadosUsuario } = useSelector((state) => state.liquidaciones);

  const [openAlert, setOpenAlert] = React.useState(false);
  const [openModalAuditar, setOpenModalAuditar] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState(false);

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleLiberar = () => {
    dispatch(putLiberarComprobante(
      comprobantesTomadosUsuario.find((item) => item.idUsuarioTomado === idUsuario && item.fechaLiberado === null)?.id,
      'currentUser',
      true,
      setOpenAlert,
      item,
      setOpenModalAuditar,
      null,
      comprobantesTomadosUsuario.find((item) => item.idUsuarioTomado === idUsuario && item.fechaLiberado === null)?.idComprobante,
    ));
    setOpenAlert(false);
  };

  const disabled = (item?.expediente?.idEstado ===
    LIQUIDACIONES_COMPROBANTES_ESTADOS.ANULADA ||
    item?.expediente?.idEstado ===
    LIQUIDACIONES_COMPROBANTES_ESTADOS.PAGADA ||
    item?.expediente?.idEstado ===
    LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_ENVIO_TESORERIA ||
    item?.expediente?.idEstado ===
    LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA ||
    item?.expediente?.idEstado ===
    LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO)


  return (
    <>
      {openAlert && (
        <Dialog
          open={openAlert}
          onClose={handleCloseAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography
                style={{ color: "#222" }}
              >
                Actualmente tiene una solicitud tomada, desea liberarla para tomar el Comprobante N°{item.idComprobante}?
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseAlert}
              variant="contained"
              color="primary"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleLiberar}
              variant="contained"
              color="primary"
              autoFocus
            >
              Liberar
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openModalAuditar &&
        <ModalAuditarFactura
          disabled={disabled}
          fechaDesde={fechaDesde}
          fechaHasta={fechaHasta}
          open={openModalAuditar}
          closeModalHandler={() => {
            setOpenModalAuditar(false);
          }}
          formatCurrencyPesos={formatCurrencyPesos}
          idEfectorFacturacion={idEfectorFacturacion}
          estadoComprobantes={estadoComprobantes}
        />
      }
      {openModalHistorialCambios &&
        <ModalHistorialExpedientes
          open={openModalHistorialCambios}
          closeModalHandler={() => {
            setOpenModalHistorialCambios(false);
          }}
          expediente={{ idExpediente: item?.idComprobante }}
        />
      }
      <TableRow className={classes.root} >
        {parseInt(estadoComprobantes) === LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_ENVIO_TESORERIA &&
          <TableCell padding="checkbox">
            <Checkbox
              checked={isItemSelected}
              inputProps={{ "aria-labelledby": labelId }}
              onClick={(event) => handleClick(event, item)}
            />
          </TableCell>
        }
        <TableCell align="center" sx={{ padding: "10px" }}>
          <InfoHistorialIcon
            onClick={() => setOpenModalHistorialCambios(true)}
          />
        </TableCell>
        <TableCell align="center">
          <IconEstado
            useColorTable={true}
            texto={item?.expediente?.estadoComprobante?.letraLiquidaciones}
            backgroundColor={item?.expediente?.estadoComprobante?.colorLiquidaciones}
            descripcion={item?.expediente?.estadoComprobante?.descripcionLiquidaciones}
          />
        </TableCell>
        <TableCell align="left">{item?.idComprobante}</TableCell>
        <TableCell align="left" style={{ minWidth: 150 }}>
          {`${item?.nroSucursal.toString().padStart((5), '0')}-${item?.nroFactura.toString().padStart((8), '0')}`}
        </TableCell>
        <TableCell align="left">{item?.comprobanteContrato?.efectorFacturacion?.razonSocial}</TableCell>
        <TableCell align="left">{item?.comprobanteContrato?.efectorFacturacion?.cuit}</TableCell>
        <TableCell align="left">
          {(() => {
            switch (item?.procedencia?.descripcion) {
              case 'Mail':
                return 'M';
              case 'Correo':
                return 'C';
              case 'Otras Areas':
                return 'O';
              case 'En mano':
                return 'EM';
              default:
                return '';
            }
          })()}
        </TableCell>
        <TableCell align="left">{`${formatCurrencyPesos(item?.totalComprobante)}`}</TableCell>
        <TableCell align="center">{item?.tipoFactura?.descripcion}</TableCell>
        <TableCell align="left">
          {new Date(item.expediente?.fechaRecepcion).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="left">
          {item.fechaVencimiento
            ? new Date(item.fechaVencimiento).toLocaleString("es", optionsfecha)
            : null
          }
        </TableCell>
        <TableCell align="left">
          {item.comprobantesTomados[0]?.usuarioTomado?.userName}
        </TableCell>
        <TableCell>
          {item?.relacionVoucherExpediente?.[0]?.idSolicitudPago ?
            item?.relacionVoucherExpediente[0]?.idSolicitudPago
            : null}
        </TableCell>
        <TableCell>
          {(item?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA ||
            item?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION ||
            item?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA ||
            (item?.expediente?.idEstado ===
              LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO) ||
            item?.expediente.idEstado === LIQUIDACIONES_COMPROBANTES_ESTADOS.PROFORMAS_PENDIENTES_CARGA) && (
              <Button
                style={{ fontSize: "0.8rem" }}
                disabled={
                  item.comprobantesTomados?.length > 0 &&
                  item.comprobantesTomados[0]?.idUsuarioTomado !== idUsuario
                }
                variant="contained"
                color="primary"
                onClick={() => {
                  dispatch(postTomarComprobante(item, setOpenModalAuditar, setOpenAlert));
                }}
              >
                Tomar
              </Button>
            )}
          {(item?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_ENVIO_TESORERIA ||
            item?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA ||
            item?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.ANULADA ||
            item?.expediente?.idEstado ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.PAGADA) && (
              <Button
                style={{ fontSize: "0.8rem" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  dispatch(setComprobanteSeleccionado(item));
                  setOpenModalAuditar(true);
                }}
              >
                Ver
              </Button>
            )}
        </TableCell>
      </TableRow>
    </>
  );
};

